import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap'
// import { Table,Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import useListComparable from './useListComparable';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import AddEditDataForm from './AddEditDataForm';
import { useBlocker, useLocation, useNavigate } from 'react-router-dom';
import {DndContext, closestCenter, useSensor, useSensors, PointerSensor, KeyboardSensor} from '@dnd-kit/core'
import {arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy} from '@dnd-kit/sortable'
import SortableRow from './SortableRow ';
import { useUnsavedChanges } from 'context/UnsavedChangesContext';
import useIsSelectedComp from './useIsSelectedComp';
import toast from 'react-hot-toast';
import useUpdateSeq from './useUpdateSeq';

const ReviewTable = () => {
    // navigation
    const navigate = useNavigate()
    const location = useLocation();
    const orderId = location.state?.orderId;
    const fileNumber = location.state?.file_num;
    const productType = location.state?.productType;

    console.log("product",location.state?.productType)

    // pagination
    const[currentPage, setCurrentPage] = useState(1);
    const pageSize=10
    
    // hook for getting comparables data
    const{isPending, isSuccess, isError, error, data:comparables,refetch} = useListComparable(currentPage,pageSize,orderId);
    console.log(comparables)
    // hook for handling the isSelected for comoarables
    const{isSelecting, isSelected, updateIsSelected,mutateAsync} = useIsSelectedComp();
    // hook to handle the seq update
    const{isUpdatingSeq,isUpdatedSeq,updateCompSeq}=useUpdateSeq();

    // state for unselected comparables
    const[unselected,setUnselected]=useState([]);
    
     // FIX #2: Local state to manage the order of data without mutating the cache.
    const [orderedData, setOrderedData] = useState([]);

    const[originalData,setOriginalData] = useState([]);
    const[isOrderChanged,setIsOrderChanged] = useState(false);
    // context
    const { isBlocked,setIsBlocked } = useUnsavedChanges(); 
    // This effect connects your local 'isOrderChanged' state
    // to the global 'isBlocked' state.
    useEffect(() => {
        setIsBlocked(isOrderChanged);

        // This is a good practice: when the component unmounts,
        // ensure the block is removed.
        return () => {
            setIsBlocked(false);
        };
    }, [isOrderChanged, setIsBlocked]);

    // alert modal
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    useEffect(()=>{
        refetch();
    },[orderId,refetch])
    
    // for getting the last index number to set the seq
    const[lastIndexNum,setLastIndexNum] = useState(0);
    
    // Populate local state when fetched data arrives or changes.
    useEffect(() => {
        if (isSuccess && comparables?.data) {
            setOrderedData(comparables.data);

            setOriginalData(comparables.data);
            // when new data is fetched, reset the changed status
            setIsOrderChanged(false)

            // exculde sub
            const compsOnly = comparables.data.slice(1);
            const maxSeq = Math.max(...compsOnly.map(c=>c.sequence || 0));
            setLastIndexNum(maxSeq || compsOnly.length)
        }
    }, [comparables, isSuccess]);

    console.log("comps index",lastIndexNum)
    //useeffect to compare the orders
    useEffect(()=>{
        // dont compare until both arrays are populated
        if (originalData.length === 0 || orderedData.length !== originalData.length) {
            return;
        }
        // The most efficient way to check for reordering is to compare an array of IDs.
        const originalIds = originalData.map(item=> item.id);
        const currentIds = orderedData.map(item=> item.id);

         // If the stringified versions of the ID arrays are not equal, the order has changed.
         if(JSON.stringify(originalIds) !== JSON.stringify(currentIds)){
            setIsOrderChanged(true);
         }else{
            setIsOrderChanged(false);
         }
    },[orderedData, originalData]) 

    // FIX #1: Define sensors at the top level of the component.
    // This ensures hooks are called on every render, in the same order.
    const sensors = useSensors(
        useSensor(PointerSensor, {
            // This is the magic line!
            // Require the mouse to move 10 pixels before initiating a drag
            activationConstraint: {
                distance: 10,
            },
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    // Style object for the sticky table headers
    const stickyHeaderStyle = {
        position: "sticky",
        top: 0,
        backgroundColor: "white",
        zIndex: 5, // Ensures header is above the scrolling content
        fontSize:"13.7px" //this is only for review table
    };

    //for modal
    const[isOpen,setIsOpen] = useState(false);
     // state to track whether its add or edit
    const[isEditMode,setIsEditMode]=useState(false)
    // stores comp/subj data for editing
    const[selectedComp,setSelectedComp]=useState(null)

    // for counter
    const [counter, setCounter] = useState(3);
    const MAX_LIMIT = 15;
    const MIN_LIMIT = 3;
    const [selectedComparable, setSelectedComparable] = useState(null);

    // effect to select comparable based on counter
    useEffect(() => {
        if (orderedData.length > 1 && counter >= 1) {
            // Select from index 1 (inclusive) to counter (inclusive)
            const endIndex = Math.min(counter + 1, orderedData.length); // +1 because slice is exclusive on the end
            const selected = orderedData.slice(1, endIndex); // skip subject at index 0
            setSelectedComparable(selected);
        } else {
            setSelectedComparable([]);
        }
    }, [counter, orderedData]);


    const AddModal = () => {
        // <-- NEW: Add the check here
        if (isBlocked) {
            if (!window.confirm('You have unsaved changes. Are you sure you want to add a new comparable? Your current changes will not be saved.')) {
                // If the user clicks "Cancel", do nothing.
                return;
            }
        }
        // setting index
        if(comparables && comparables.length)
        // If not blocked, or if the user confirmed, proceed to open the modal.
        setIsEditMode(false);
        setSelectedComp(null);
        setIsOpen(true);
    };

    const EditModal = (comp) => {
        // You might want to protect this one as well, just in case.
        if (isBlocked) {
            if (!window.confirm('You have unsaved changes. Are you sure you want to edit a different item? Your current changes will not be saved.')) {
                return;
            }
        }
        setIsEditMode(true);
        setSelectedComp(comp);
        setIsOpen(true);
    };

    const closeModal=()=>{
        setIsEditMode(false)
        setSelectedComp(null)
        setIsOpen(false)
    }

    // Drag end handler that updates the local state
    const handleDragEnd = ({ active, over }) => {
        if (!over || active.id === over.id) return;

        setOrderedData((currentData) => {
            const oldIndex = currentData.findIndex((c) => c.id === active.id);
            const newIndex = currentData.findIndex((c) => c.id === over.id);

            const activeItem = currentData[oldIndex];
            const overItem = currentData[newIndex];

            if (activeItem.comp_type === 'subject' || overItem.comp_type === 'subject') {
                return currentData; // Return original data if move is invalid
            }
            // Update local state, not the cached `comparables` data
            return arrayMove(currentData, oldIndex, newIndex);
        });
    };
    // function to hangdle the save changes
    const handleSaveChanges=()=>{
        console.log("Change detected! Saving new order.")

        const newOrderIds = orderedData.map(comp=>comp.id)
        console.log("New order of IDs:", newOrderIds);

        // update the data with new seq numbers
        const updatedData = orderedData.map((comp,index)=>({
            // if(index===0){
            //     return {...comp,sequence: 1};
            // }
            // return {
            //     ...comp,
            //     sequence:index + 1
            // }
            ...comp, sequence:index + 1
        }))

        console.log("Updated data with new seq:", updatedData);

        // creating array with compi_id and seq
        const compSeqPayload = updatedData.slice(1).map(comp=>({
            comp_id:comp.comp_id,
            seq:comp.sequence
        }))
        console.log("Payload to send:", compSeqPayload);
        
        updateCompSeq(compSeqPayload)
        setOriginalData(orderedData)
    }
    // function to handle preview
    const handlePreview=  async()=>{
        if(!orderedData || orderedData.length === 0) return;

        // subject always at index 0
        const subject = orderedData[0];

        // comparables from index 1 to 3 by  default
        const defaultComparableCount = Math.max(counter,3);

        // according to user selecting the index
        const endIndex = Math.min(defaultComparableCount + 1, orderedData.length);
        console.log("endIndex",endIndex)
        const selectedComparables = orderedData.slice(1, endIndex);
        console.log("selected comps",selectedComparables)
        // unselcted comp
        const unselectedComp = orderedData.slice(endIndex)
        console.log("unselcted",unselected)
        const previewData =[subject, ...selectedComparables];
    
        // Find items that need to be changed from FALSE -> TRUE
        const itemsToSelect = selectedComparables.filter(item => item.is_selected === false);
        console.log("items to select",itemsToSelect)
         // Find items that need to be changed from TRUE -> FALSE
        const itemsToDeselect = unselectedComp.filter(item => item.is_selected === true);
        console.log("item to deselect",itemsToDeselect)
        // Combine them into a single list of items to update
        const allItemsToToggle = [...itemsToSelect, ...itemsToDeselect];

        try{
            if(allItemsToToggle.length > 0){
                const idsToToggle = allItemsToToggle.map(item => item.comp_id);
                const payload ={
                    "comp_ids":idsToToggle
                }
                await mutateAsync(payload)
            }
        }catch(error){
            toast.error('Something wrong happen,Try again later')
            console.log("Navigation stopped because the API call failed.");
        }

        navigate('/preview-page', {state:{previewData,orderId,fileNumber,productType}})
    }

    // setting validation for add comp button if more 15 index reached disable the button
    const [index,setIndex] = useState(false);
    useEffect(()=>{
        if(orderedData && orderedData.length > 15){
            setIndex(true)
        }
    },[orderedData])
  return (
    <Container fluid>
        <Row>
            <Row className='mb-3 border-bottom pb-2 mt-5'>
                <Col>
                    <h5 className='fw-bold'>Property Comparable Analysis</h5>
                </Col>
                <Col>
                    File Number: {fileNumber}
                </Col>
                <Col>
                    <Row className='mb-3'>
                        <Col md="3">
                            <div className="d-flex align-items-center gap-2">
                            <Label htmlFor='comparableCount' className='form-label mb-0' style={{whiteSpace:"nowrap"}}>Comparable Count:</Label>
                            <Button
                                color="outline-primary"
                                onClick={() => counter > MIN_LIMIT && setCounter(counter - 1)}
                                disabled={counter <= MIN_LIMIT}
                            >
                                -
                            </Button>
                            <input
                                type="number"
                                className="form-control text-center"
                                style={{ width: '70px' }}
                                value={counter}
                                onChange={(e) => {
                                const val = parseInt(e.target.value, 10);
                                if (!isNaN(val) && val >= MIN_LIMIT && val <= MAX_LIMIT) {
                                    setCounter(val);
                                }
                                }}
                                min={MIN_LIMIT}
                                max={MAX_LIMIT}
                            />
                            <Button
                                color="outline-primary"
                                onClick={() => counter < MAX_LIMIT && setCounter(counter + 1)}
                                disabled={counter >= MAX_LIMIT}
                            >
                                +
                            </Button>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"end", gap:"12px"}}>
                        {isOrderChanged && (
                        <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                            onClick={handleSaveChanges}
                        >
                            Save Changes
                        </Button>
                    )}
                        <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                            onClick={AddModal} disabled={index}
                        >
                            Add Comparable
                        </Button>
                        <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                            onClick={handlePreview} disabled={isBlocked || isPending}
                        >
                            Preview
                        </Button>
                        {/* <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}>
                            Remove Selected
                        </Button> */}
                    </div>
                </Col>
            </Row>
        </Row>
        <Row>
            <div className='table-rep-plugin'>
                <div className='table-responsive mb-0' style={{ maxHeight: "500px",minHeight:"500px", overflowY: "auto",overflowX:"auto",width:"100%",whiteSpace:"nowrap" }}>
                    <table className='table table-striped table-bordered'>
                        <thead>
                            <tr>
                                <th style={stickyHeaderStyle}></th> 
                                {/* <th style={stickyHeaderStyle}>SL.No</th> */}
                                <th style={stickyHeaderStyle}>Type</th>
                                {/* <th style={stickyHeaderStyle}>Owner</th> */}
                                {/* <th style={stickyHeaderStyle}>Id</th> */}
                                <th style={{...stickyHeaderStyle,position:'sticky',left:'10px',zIndex:6}}>Address</th>
                                <th style={stickyHeaderStyle}>Proximity</th>
                                <th style={stickyHeaderStyle}>Location</th>
                                <th style={stickyHeaderStyle}>Sale Price</th>
                                <th style={stickyHeaderStyle}>Date of Sale</th>
                                <th style={stickyHeaderStyle}>Age</th>
                                <th style={stickyHeaderStyle}>GLA</th>
                                <th style={stickyHeaderStyle}>Price/GLA</th>
                                <th style={stickyHeaderStyle}>Site Size</th>
                                <th style={stickyHeaderStyle}>Site View</th>
                                <th style={stickyHeaderStyle}>Design</th>
                                <th style={stickyHeaderStyle}>Condition</th>
                                <th style={stickyHeaderStyle}>Total Rooms</th>
                                <th style={stickyHeaderStyle}>Bed Rooms</th>
                                <th style={stickyHeaderStyle}>Bath(s)</th>
                                <th style={stickyHeaderStyle}>Basement</th>
                                <th style={stickyHeaderStyle}>Heating/Cooling</th>
                                <th style={stickyHeaderStyle}>Garage</th>
                                <th style={stickyHeaderStyle}>Porch</th>
                                <th style={stickyHeaderStyle}>MLS Listing Number</th>
                                <th style={stickyHeaderStyle}>Records</th>
                                <th style={stickyHeaderStyle}>Overall Comparison</th>
                                <th style={stickyHeaderStyle}>Actions</th>
                            </tr>
                        </thead>
                            {isPending && (
                            <tbody>
                                <tr>
                                    <td colSpan="18" className="text-center"><Spinner/></td>
                                </tr>
                            </tbody>
                        )}

                        {isError && (
                             <tbody>
                                <tr>
                                    <td colSpan="18" className="text-center text-danger">
                                        Error fetching data: {error.message}
                                    </td>
                                </tr>
                            </tbody>
                        )}

                        {
                        !isPending && orderedData.length === 0 && (
                            <tbody>
                            <tr>
                                <td colSpan="18" className="text-center">
                                <div className="py-4">
                                    <div className="d-flex flex-column align-items-center text-muted">
                                    <i className="bi bi-exclamation-circle fs-1 mb-2"></i>
                                    <h5 className="mb-1">No Data Found</h5>
                                    </div>
                                </div>
                                </td>
                            </tr>
                            </tbody>
                        )
                        }


                        {isSuccess &&(    <DndContext
                                sensors={sensors}
                                collisionDetection={closestCenter}
                                onDragEnd={handleDragEnd}
                            >
                                <SortableContext
                                    items={orderedData.map((comp)=>comp.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <tbody>
                                        {orderedData.map((comp,index)=>(
                                                <SortableRow
                                                    key={comp.id}
                                                    comp={comp}
                                                    index={index}
                                                    onEdit={EditModal}
                                                    isSelected={selectedComparable?.some(sel => sel.id === comp.id)}
                                                />
                                            ))
                                        }
                                    </tbody>
                                </SortableContext>
                            </DndContext>
                        )}
                    </table>
                </div>
            </div>
            {/* modal */}
            <Modal isOpen={isOpen} size="xl" backdrop="static" keyboard={false} toggle={null} fullscreen='xl' fade scrollable centered={true}>
                <ModalHeader
                    close={
                        <button type="button" className="btn-close" onClick={closeModal}/>
                    }
                >
                {isEditMode ? "Edit Subject or Comparable here" : "Add Subject or Comparable here"}
                </ModalHeader>
                <ModalBody>
                    <AddEditDataForm
                        lastInd={lastIndexNum}
                        isEditMode={isEditMode}
                        objData={selectedComp}
                        onClose={closeModal}
                        orderId={orderId}
                    />
                </ModalBody>
            </Modal>

            {/* NEW: Confirmation Modal for unsaved changes (React Router) */}
            {/* <Modal isOpen={showConfirmModal} centered>
                <ModalHeader>Leave Page?</ModalHeader>
                <ModalBody>
                    You have unsaved changes. Are you sure you want to leave? Your changes will be lost.
                </ModalBody>
                <div className="modal-footer">
                    <Button color="secondary" onClick={() => {
                        setShowConfirmModal(false);
                        blocker.reset?.(); // Cancel the navigation and stay on the page
                    }}>
                        Stay
                    </Button>
                    <Button color="danger" onClick={() => {
                        setShowConfirmModal(false);
                        blocker.proceed?.(); // Proceed with the navigation
                    }}>
                        Leave
                    </Button>
                </div>
            </Modal> */}
        </Row>
    </Container>
  )
}

export default ReviewTable